import {
  // createAction,
  handleActions
} from "redux-actions";

import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_FILTERS_LOADING,
  SET_LOCATION_FILTERS_LOADING,
  SET_SITE_FILTERS_LOADING,
  UPDATE_DATES,
  UPDATE_REGIONS,
  UPDATE_SITES,
  UPDATE_LOCATIONS,
  FETCH_TABLE_DATA_SUCCESS,
  // FETCH_EVERYTHING_NEW_SUCCESS,
  // FETCH_EVERYTHING_NEW_FAILURE,
  FETCH_INTROS_CONVERSIONS_SUCCESS,
  FETCH_INTROS_CONVERSIONS_FAILURE,
  FETCH_FIRST_VISITS_SUCCESS,
  FETCH_FIRST_VISITS_FAILURE,
  FETCH_ALL_REVENUE_SUCCESS,
  FETCH_ALL_REVENUE_FAILURE,
  FETCH_LEADS_SUCCESS,
  FETCH_LEADS_FAILURE,
  FETCH_MEMBERSHIPS_SUCCESS,
  FETCH_MEMBERSHIPS_FAILURE,
  FETCH_AVERAGES_SUCCESS,
  FETCH_AVERAGES_FAILURE,
  FETCH_FILTERS_SUCCESS,
  FETCH_FILTERS_EXCLUDE_SITES_SUCCESS,
  SET_TABLES_LOADING,
  UPDATE_CUSTOM_RANGE
} from "../sagas/multiLocation/multiLocation";

const initialState = {
  isLoading: true,
  currentUser: {},
  introConversions: {
    tableInfo: {
      data: []
    }
  },
  firstVisits: {
    tableInfo: {
      data: []
    }
  },
  allRevenue: {
    tableInfo: {
      data: []
    }
  },
  leads: {
    tableInfo: {
      data: []
    }
  },
  memberships: {
    tableInfo: {
      data: []
    }
  },
  averages: {
    tableInfo: {
      data: []
    }
  },
  selectedRequestDates: {},
  selectedRegions: {},
  selectedSites: {},
  selectedLocations: {},
  filtersDirty: false,
  filtersLoading: true,
  siteFiltersLoading: false,
  locationFiltersLoading: false,
  tablesLoading: false,
  availableFilters: {
    filters: {
      regions: {},
      objects: {},
      locations: {}
    }
  },
  haveRequestError: false,
  requestError: {},
  selectedRangeOption: {},
  rangeOptions: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload,
      haveRequestError: false
    }),
    [SET_TABLES_LOADING]: (state, action) => ({
      ...state,
      tablesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload || state.filtersDirty
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      filtersLoading: action.payload || state.filtersLoading
    }),
    [SET_SITE_FILTERS_LOADING]: (state, action) => ({
      ...state,
      siteFiltersLoading: action.payload || state.siteFiltersLoading
    }),
    [SET_LOCATION_FILTERS_LOADING]: (state, action) => ({
      ...state,
      locationFiltersLoading: action.payload || state.locationFiltersLoading
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      availableFilters: action.payload || state.availableFilters,
      filtersLoading: false,
      siteFiltersLoading: false,
      locationFiltersLoading: false,
      selectedRegions: action.payload.filters.regions,
      selectedSites: action.payload.filters.objects,
      selectedLocations: action.payload.filters.locations
    }),
    [FETCH_FILTERS_EXCLUDE_SITES_SUCCESS]: (state, action) => ({
      ...state,
      availableFilters: action.payload || state.availableFilters,
      filtersLoading: false,
      locationFiltersLoading: false,
      selectedLocations: action.payload.filters.locations
    }),

    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [UPDATE_REGIONS]: (state, action) => ({
      ...state,
      selectedRegions: action.payload || state.selectedRegions,
      filtersDirty: true
    }),
    [UPDATE_SITES]: (state, action) => ({
      ...state,
      selectedSites: action.payload || state.selectedSites,
      filtersDirty: true,
      siteFiltersLoading: false
    }),
    [UPDATE_LOCATIONS]: (state, action) => ({
      ...state,
      selectedLocations: action.payload || state.selectedLocations,
      filtersDirty: true,
      locationFiltersLoading: false
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),

    [FETCH_INTROS_CONVERSIONS_SUCCESS]: (state, action) => ({
      ...state,
      introConversions: action.payload || state.introConversions
    }),
    [FETCH_INTROS_CONVERSIONS_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [FETCH_FIRST_VISITS_SUCCESS]: (state, action) => ({
      ...state,
      firstVisits: action.payload || state.firstVisits
    }),
    [FETCH_FIRST_VISITS_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [FETCH_ALL_REVENUE_SUCCESS]: (state, action) => ({
      ...state,
      allRevenue: action.payload || state.allRevenue
    }),
    [FETCH_ALL_REVENUE_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      haveRequestError: true
    }),
    [FETCH_LEADS_SUCCESS]: (state, action) => ({
      ...state,
      leads: action.payload || state.leads,
      filtersDirty: false
    }),
    [FETCH_LEADS_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [FETCH_MEMBERSHIPS_SUCCESS]: (state, action) => ({
      ...state,
      memberships: action.payload || state.memberships,
      filtersDirty: false
    }),
    [FETCH_MEMBERSHIPS_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [FETCH_AVERAGES_SUCCESS]: (state, action) => ({
      ...state,
      averages: action.payload || state.averages,
      filtersDirty: false
    }),
    [FETCH_AVERAGES_FAILURE]: (state, action) => ({
      ...state,
      requestError: action.error.response.data || state.requestError,
      isLoading: false,
      haveRequestError: true
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptions(
        state.currentUser.params.calendarEndDate,
        state.currentUser.params.calendarStartDate
      ),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.params.calendarEndDate,
        action.payload,
        state.currentUser.params.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    })
  },
  initialState
);
